import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

import { isDevelopment } from "@utils/constants";

// Polyfill global pour Buffer
import { Buffer } from "buffer";
window.Buffer = window.Buffer || Buffer;

/**
 * Wrapper component for React Strict Mode
 * Only applies strict mode in development environment
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 */
// eslint-disable-next-line react-refresh/only-export-components
const StrictModeWrapper = ({ children }) => {
  if (isDevelopment()) {
    return <React.StrictMode>{children}</React.StrictMode>;
  }
  return children;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>
);

/**
 * Global error handler for unhandled promise rejections
 */
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

/**
 * Global error handler for uncaught exceptions
 */
window.addEventListener("error", (event) => {
  console.error(
    "Global error:",
    event.error?.message || event.error?.toString() || "Unknown error"
  );
});

/**
 * Performance monitoring for development environment
 */
if (isDevelopment() && "performance" in window) {
  window.addEventListener("load", () => {
    const perfData = performance.getEntriesByType("navigation")[0];
    console.log("📈 Performance metrics:", {
      domContentLoaded: Math.round(
        perfData.domContentLoadedEventEnd - perfData.domContentLoadedEventStart
      ),
      loadComplete: Math.round(perfData.loadEventEnd - perfData.loadEventStart),
      totalLoadTime: Math.round(perfData.loadEventEnd - perfData.fetchStart),
    });
  });
}